// Argus — File Explorer Options modal (fix #4 round 2): preference flags persist localStorage per agent.
// Show folder tree | Show preview pane | Show system files | Show hidden files.

import { Box, Button, FormControlLabel, Switch, Typography } from '@mui/material';
import { ArgusDialog } from '../../components/floating/ArgusDialog';

export interface FileExplorerOptions {
  treeOpen: boolean;
  previewOpen: boolean;
  showSystemFiles: boolean;
  showHiddenFiles: boolean;
  /** True = lazy load thumbnails reale (frame video / preview imagine real). False = doar iconițe extension. */
  realMediaThumbnails: boolean;
}

export interface FileExplorerOptionsDialogProps {
  open: boolean;
  onClose: () => void;
  value: FileExplorerOptions;
  onChange: (next: FileExplorerOptions) => void;
}

export function FileExplorerOptionsDialog({ open, onClose, value, onChange }: FileExplorerOptionsDialogProps): JSX.Element {
  const update = (patch: Partial<FileExplorerOptions>) => onChange({ ...value, ...patch });
  return (
    <ArgusDialog
      open={open}
      onClose={onClose}
      title="File Explorer options"
      maxWidth="sm"
      actions={<Button onClick={onClose} variant="contained">Close</Button>}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, py: 1 }}>
        <Typography variant="caption" color="text.secondary">Layout</Typography>
        <FormControlLabel
          control={<Switch size="small" checked={value.treeOpen} onChange={(e) => update({ treeOpen: e.target.checked })} />}
          label="Show folder tree"
        />
        <FormControlLabel
          control={<Switch size="small" checked={value.previewOpen} onChange={(e) => update({ previewOpen: e.target.checked })} />}
          label="Show preview pane"
        />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>Filters</Typography>
        <FormControlLabel
          control={<Switch size="small" checked={value.showSystemFiles} onChange={(e) => update({ showSystemFiles: e.target.checked })} />}
          label="Show system files"
        />
        <FormControlLabel
          control={<Switch size="small" checked={value.showHiddenFiles} onChange={(e) => update({ showHiddenFiles: e.target.checked })} />}
          label="Show hidden files"
        />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>Thumbnails</Typography>
        <FormControlLabel
          control={<Switch size="small" checked={value.realMediaThumbnails} onChange={(e) => update({ realMediaThumbnails: e.target.checked })} />}
          label="Generate real thumbnails from media (vs default OS icons)"
        />
        <Typography variant="caption" color="text.disabled" sx={{ mt: -0.5, ml: 4 }}>
          When enabled, picture/video files in Thumbnails view show real preview frames extracted by the agent. Disable for slower networks or strict bandwidth budgets.
        </Typography>
      </Box>
    </ArgusDialog>
  );
}
